import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanDetails from "UnitPlanDetails";

export default store => ({
  path: "units",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "unitPlans" */ "./components"),
      import(/* webpackChunkName: "unitPlans" */ "./modules/UnitLibraryModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "unitLibrary",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [UnitPlanDetails(store)],
});
